import { render, staticRenderFns } from "./add-applicant-modal.vue?vue&type=template&id=489fdf9c"
import script from "./add-applicant-modal.vue?vue&type=script&lang=js"
export * from "./add-applicant-modal.vue?vue&type=script&lang=js"
import style0 from "./add-applicant-modal.vue?vue&type=style&index=0&id=489fdf9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports